var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.961H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 214.913H206.603V341.961H118.631V214.913H0V127.042H118.631V-0.00585938H206.603V127.042H513V192.369V214.913Z",
    fill: "#0F61A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 149.586V192.369H184.059V341.961H141.275V192.369H0V149.586H141.275V-0.00585938H184.059V149.586H513Z",
    fill: "#E50E3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFo);
export default __webpack_public_path__ + "static/media/FO.4a6b443522fe026a2a946dad6c2ba521.svg";
export { ForwardRef as ReactComponent };